module.exports = __webpack_public_path__ + "static/img/19090D_1_R_20200922_LC.440a2fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19090D_1_R_20200922_LC.png
// module id = 5vDG
// module chunks = 0